const EventEmitter = require('eventemitter3')

const parseHtmlTags = require('./parse-html-tags')

const {
  htmlOrScriptOrIframeTagFromString,
  isGameIntegrationPage
} = require('./cxf-runtime-private')

const appendHtmlTagFor = function (htmlOrUrl) {
  const html = htmlOrScriptOrIframeTagFromString(htmlOrUrl).trim()
  if (html.match(/^\s*<script\b/i)) {
    const loadScript = require('@segment/load-script')
    const allTags = parseHtmlTags(html, 'script')
    return allTags
      .filter(tag => tag[parseHtmlTags.TAG] === 'script')
      .filter(tag => tag.src)
      .map(tag => tag.src)
      .map(loadScript)
      .shift()
  }

  const body = document.getElementsByTagName('body')[0]
  body.insertAdjacentHTML('beforeend', html)
  return body.lastChild
}

let instance = null
const initializeDefaults = {
  document: window.document
}

const initialize = ({document} = initializeDefaults) => {
  if (instance) {
    console.warn('CXF was already initialzed.')
    return instance
  }

  if (!isGameIntegrationPage()) {
    console.warn('Load CXF after the Game Integration Page has initialized; some functionality may not work.')
  }

  const createContext = function () {
    const gameAlias = require('@goodgamestudios/game-alias')
    const gameId = getAttributeByElementId('gameId', 'data')

    const context = {
      gameId,
      game: gameAlias.name(gameId),
      networkId: getAttributeByElementId('networkId', 'data'),
      env: getAttributeByElementId('env', 'data') || process.env.NODE_ENV
    }

    return context

    function getAttributeByElementId(elementId, attrName) {
      const element = document.getElementById(elementId)
      return element && element.getAttribute(attrName)
    }
  }

  const context = createContext()
  instance = Object.assign(
    new EventEmitter(),
    {pubnub: require('./cxf-pubnub').initializePubnub(context.game, context.env)},
    {appendHtmlTagFor},
    context
  )
  return instance
}

module.exports = initialize
module.exports.appendHtmlTagFor = appendHtmlTagFor
